// extracted by mini-css-extract-plugin
export var aiButtonContainer = "_94-0";
export var orangeButton = "_94-1";